import classNames from 'classnames'
import kebabCase from 'lodash.kebabcase'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import { Text } from 'marketing-site/src/library/elements/Text'
import { CTATheme, mq } from 'marketing-site/src/library/utils'
import React from 'react'

import { IProps } from './index'

export const GatedContent = ({
  eyebrow,
  title,
  subhead,
  image,
  cta,
  layout,
  backgroundColor,
}: IProps): React.ReactElement => {
  const classes = classNames('gated-content', 'grid-layout', {
    'gated-content--inset': layout === 'Inset',
    [`mvp-background-color-${kebabCase(backgroundColor)}`]: backgroundColor,
  })

  return (
    <div className={classes}>
      <div className="gated-content__inner">
        <div className="gated-content__header">
          {eyebrow && (
            <div className="gated-content__eyebrow">
              <Text size="eyebrow">{eyebrow}</Text>
            </div>
          )}

          <div className="gated-content__title">
            <Text size="heading-3">{title}</Text>
          </div>

          {subhead && (
            <div className="gated-content__subhead">
              <Text size="body">{subhead}</Text>
            </div>
          )}
        </div>

        {cta && (
          <div className="gated-content__cta">
            <CTALink {...cta} bgColor={CTATheme.BlueFill} />
          </div>
        )}

        {image && <div className="gated-content__image">{image}</div>}
      </div>

      <style jsx>{`
        .gated-content {
          padding-left: 1.25rem;
          padding-right: 1.25rem;

          &--inset {
            border-radius: 1rem;
            margin-left: 1.25rem;
            margin-right: 1.25rem;
            padding-left: 0;
            padding-right: 0;

            .gated-content__inner {
              align-items: center;
              padding-left: 0;
              padding-right: 0;

              .gated-content__header,
              .gated-content__cta,
              .gated-content__image {
                padding-left: 2rem;
                padding-right: 2rem;
              }
            }
          }

          &__image,
          &__header,
          &__cta {
            grid-column: 1/-1;
          }
          &__header {
            display: flex;
            flex-direction: column;
            text-align: center;
          }
          &__eyebrow {
            margin-bottom: 1rem;
          }
          &__title {
            margin-bottom: 1rem;
          }
          &__subhead {
            margin-bottom: 2em;
          }
          &__cta {
            margin-bottom: 2.5em;
            display: flex;
            justify-content: center;
            flex-direction: column;
          }
          &__image {
            :global(img) {
              border-radius: 1rem;
            }
          }
        }
        @media (${mq.tablet}) {
          .gated-content {
            &:not(.gated-content--inset) {
              padding-left: 2rem;
              padding-right: 2rem;
            }
            &--inset {
              border-radius: 1.5rem;
              margin-left: 2rem;
              margin-right: 2rem;

              .gated-content__inner {
                .gated-content__header,
                .gated-content__cta,
                .gated-content__image {
                  padding-left: 0;
                  padding-right: 0;
                }
              }
            }
            &__header,
            &__cta {
              grid-column: 2/-2;
            }
            &__cta {
              flex-direction: row;
              margin-bottom: 0;
              align-items: center;
            }
            &__image {
              grid-column: 3/-3;
              margin-top: 3.5rem;
              :global(img) {
                border-radius: 1.745rem;
              }
            }
          }
        }
        @media (${mq.desktop}) {
          .gated-content {
            &__inner {
              align-items: center;
            }
            &--inset {
              margin-left: 2.5rem;
              margin-right: 2.5rem;
            }
            &__header {
              grid-column: 7/-2;
              text-align: left;
            }
            &__image {
              grid-column: 2/-7;
              grid-row: 1/3;
              margin-top: 0;
            }
            &__cta {
              justify-content: start;
              grid-column: 7/-2;
              margin-bottom: 0;
            }
            &__eyebrow {
              margin-bottom: 1.25rem;
            }
            &__title {
              margin-bottom: 1rem;
            }
            &__subhead {
              margin-bottom: 2.5rem;
            }
          }
        }
        @media (${mq.desktopLg}) {
          .gated-content {
            &--inset {
              margin-left: 6.25rem;
              margin-right: 6.25rem;
            }
            &__image {
              grid-column: 2/6;
            }
          }
        }
      `}</style>
    </div>
  )
}
